import type { Blaze, Blockfrost, WebWallet } from "@blaze-cardano/sdk";
import { Dispatch } from "react";

export interface IAppState {
  blaze?: Blaze<Blockfrost, WebWallet>;
  provider?: Blockfrost;
  orderEncryptionKey?: OrderEncryptionKey;
}

export interface OrderEncryptionKey {
  session: { publicKey: Uint8Array, secretKey: Uint8Array },
  encryption: Uint8Array,
  hkdfSalt: Uint8Array,
}

export enum EAppActions {
  SET_BLAZE = "SET_BLAZE",
  SET_PROVIDER = "SET_PROVIDER",
  SET_ORDER_ENCRYPTION_KEY = "SET_ORDER_ENCRYPTION_KEY",
}

export type TAppAction =
  | {
      type: EAppActions.SET_BLAZE;
      payload: IAppState["blaze"];
    }
  | {
      type: EAppActions.SET_PROVIDER;
      payload: IAppState["provider"];
    }
  | {
      type: EAppActions.SET_ORDER_ENCRYPTION_KEY;
      payload: OrderEncryptionKey;
    };

export interface IAppContext {
  state: IAppState;
  dispatch: Dispatch<TAppAction>;
}
